import Component from "@glimmer/component";
import { capitalize, dasherize } from "@ember/string";
import { i18n } from "discourse-i18n";

export default class FormFieldBase extends Component {
  displayTitleByDefault = true;
  displayDescriptionByDefault = false;
  displayPlaceholderByDefault = true;

  #shouldDisplayProperty(argumentName, defaultSetting) {
    const hideSetting = this.args[`hide${capitalize(argumentName)}`];
    const showSetting = this.args[`show${capitalize(argumentName)}`];

    if (hideSetting && showSetting) {
      throw new Error(
        `You cannot set both hide${capitalize(
          argumentName
        )} and show${capitalize(argumentName)}`
      );
    }

    if (showSetting !== undefined) {
      return !!showSetting;
    }

    return hideSetting !== undefined ? !hideSetting : defaultSetting;
  }

  get fieldName() {
    return `circles-field__${dasherize(this.args.name)}`;
  }

  get shouldDisplayTitle() {
    return this.#shouldDisplayProperty("title", this.displayTitleByDefault);
  }

  get title() {
    if (!this.shouldDisplayTitle) {
      return null;
    }

    // allow for empty strings or nulls to be passed in
    if (this.args.title === undefined) {
      return i18n(this.titleI18n);
    }

    return this.args.title;
  }

  get titleI18n() {
    return (
      this.args.titleI18n || `discourse_circles.form.${this.args.name}.title`
    );
  }

  get shouldDisplayDescription() {
    return this.#shouldDisplayProperty(
      "description",
      this.displayDescriptionByDefault
    );
  }

  get description() {
    if (!this.shouldDisplayDescription) {
      return null;
    }

    // allow for empty strings or nulls to be passed in
    if (this.args.description === undefined) {
      return i18n(this.descriptionI18n);
    }

    return this.args.description;
  }

  get descriptionI18n() {
    return (
      this.args.descriptionI18n ||
      `discourse_circles.form.${this.args.name}.description`
    );
  }

  get shouldDisplayPlaceholder() {
    return this.#shouldDisplayProperty(
      "placeholder",
      this.displayPlaceholderByDefault
    );
  }

  get placeholder() {
    if (!this.shouldDisplayPlaceholder) {
      return null;
    }

    // allow for empty strings or nulls to be passed in
    if (this.args.placeholder === undefined) {
      return i18n(this.placeholderI18n);
    }

    return this.args.placeholder || i18n(this.placeholderI18n);
  }

  get placeholderI18n() {
    return (
      this.args.placeholderI18n ||
      `discourse_circles.form.${this.args.name}.placeholder`
    );
  }
}
